import { Card, Layout, Row, Tabs } from 'antd'
import EmailList from 'components/Main/Emails/EmailList'
import WarrantyList from 'components/Main/Warranty/WarrantyList'
import CustomBreadCrumb from '../../../components/Common/CustomBreadCrumb'
import PageTitle from '../../../elements/PageTitle'
import React, { Fragment } from 'react'

const { Content } = Layout

function Warranty(props) {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <CustomBreadCrumb items={[{ text: 'Warranty' }]} />
            <PageTitle title={'Warranty'} subtitle={'Manage Your Warranty.'} color={'#FF6138'} iconType={'email'} />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <WarrantyList {...props} />
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

export default Warranty
